import React from "react";
import { IconButton } from "react-library";
import { Colors } from "../../../constants";

const ChartOptionsIcons: React.FC<TProps> = (props) => {
  const active = props.active ?? "graph";

  const graphClasses = iconClasses + (active === "graph" ? activeClasses : " ");
  const tableClasses = iconClasses + (active === "table" ? activeClasses : " ");

  const graphStyles = {
    ...IconsStyle,
    backgroundColor: active === "graph" ? Colors.lightGreen : Colors.white,
  };
  const tableStyles = {
    ...IconsStyle,
    backgroundColor: active === "table" ? Colors.lightGreen : Colors.white,
  };

  return (
    <div className="flex content-center items-center width-max-content p-1">
      <div className={graphClasses}>
        <IconButton
          name={"chart"}
          eventName="view-graph"
          styles={graphStyles}
        />
      </div>
      <div className={tableClasses}>
        <IconButton
          name={"table"}
          eventName="view-table"
          styles={tableStyles}
        />
      </div>
      <div className={iconClasses}>
        <IconButton
          name={"download"}
          eventName="download-data"
          styles={IconsStyle}
        />
      </div>
    </div>
  );
};

export default ChartOptionsIcons;



/*
* ================== TYPES ======================
*/
type TProps = {
  active?: TVisualization;
};

export type TChartOptionsClickEvent =  Event & {
  detail: {
    id: string;
    name: string;
  }
}

export type TVisualization = "graph" | "table";

const IconsStyle = { size: "15px", padding: "5px", margin: "1px" };
const iconClasses = "shadow m-1 ";
const activeClasses = "bg-light-green ";
